import { Component, ViewChild } from '@angular/core';

import { CheckboxInput } from '../../form-controls/checkbox-input';
import { eventType } from '../../../common/text';

declare const GAMING: boolean;

@Component({
  selector: 'subscription-form',
  styleUrls: ['./subscription-form.component.scss'],
  templateUrl: './subscription-form.component.pug'
})
export class SubscriptionForm {
  @ViewChild(CheckboxInput, { static: true }) public checkbox: CheckboxInput;
  public event: string = eventType[GAMING ? 'gaming' : 'pfm'].toLowerCase();

  public valid() {
    return this.value();
  }

  public value() {
    return this.checkbox.value;
  }
}
